import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Paper from 'components/Paper';
import Input from 'components/Input';
import Button from 'components/Button';
import PasswordRules from 'components/PasswordRules';

const StyledSignupView = styled.div`
  ${Button} {
    margin-top: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const SignupView = (
  {
    email, minPasswordLength, className, error, onSubmit, onChange,
  },
) => {
  const classes = ['SignupView'];
  if (className) {
    classes.push(className);
  }

  const [password, setPassword] = useState('');

  const shouldDisableSubmit = !password || password.length < minPasswordLength || error;

  const handleChange = (e) => {
    setPassword(e.target.value);
    if (onChange) onChange();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!shouldDisableSubmit) {
      onSubmit(password);
    }
  };

  return (
    <StyledSignupView>
      <h1>Create a new password</h1>
      <p>
        Next, please create a new password for &nbsp;
        <strong>{email}</strong>
      </p>
      <Paper>
        <form onSubmit={handleSubmit} noValidate>
          <Input
            label="Create a password"
            type="password"
            placeholder="Enter your password"
            value={password}
            error={error}
            onChange={handleChange}
            focus
          />
          <PasswordRules />
          <Button
            type="submit"
            disabled={shouldDisableSubmit}
            fullWidth
            dataLayer={{ action: 'Login Portal', label: 'Password Created' }}
          >
            Continue
          </Button>
        </form>
      </Paper>
    </StyledSignupView>
  );
};

SignupView.displayName = 'SignupView';

SignupView.propTypes = {
  email: PropTypes.string.isRequired,
  minPasswordLength: PropTypes.number.isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
};

SignupView.defaultProps = {
  className: null,
  error: null,
  onChange: null,
};

export default SignupView;
